export default {
  getVideoTags: state => state.videoTags,
  getVideoTitles: state => state.videoTitles,
  getVideoAuthors: state => state.videoAuthors,
  getVideoSource: state => state.videoSource,
  getProjectDomains: state => state.projectDomains,
  getOrganizationUsers: state => state.organizationUsers,
}
